import React from 'react';
import { Avatar, Menu, MenuItem } from '@material-ui/core';
import axios from 'axios';
const options = [
    { key: 'settings', text: 'Settings' },
    { key: 'logout', text: 'Log Out', href: '/accounts/logout' },
];
function ProfileDropdown(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    function handleClick(event) {
        setAnchorEl(event.currentTarget);
    }
    function handleClickItem(event) {
        console.log('handleClickItem');
        if (event.target.id === 'settings') {
            props.openSettings();
        }
        else if (event.target.id === 'logOut') {
            const logoutEndpoint = '/rest-auth/logout/';
            axios.post(logoutEndpoint).then(res => {
                console.log(res.data);
                window.location.reload();
            });
        }
        setAnchorEl(null);
    }
    return (React.createElement("span", null,
        React.createElement(Avatar, { src: window.avatar_url, component: 'div', onClick: handleClick }),
        React.createElement(Menu, { id: 'avatar-menu', anchorEl: anchorEl, open: Boolean(anchorEl), onClose: handleClickItem },
            React.createElement(MenuItem, { id: 'settings', onClick: handleClickItem }, "Settings"),
            React.createElement(MenuItem, { id: 'logOut', onClick: handleClickItem }, "Log Out"))));
}
export default ProfileDropdown;
//# sourceMappingURL=ProfileDropdown.js.map